import React, { useState } from 'react';
import { User } from '../../services/authService';
import Sidebar from './Sidebar';
import Header from './Header';

interface LayoutProps {
  user: User;
  onLogout: () => void;
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ user, onLogout, children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    // The page scrolls with the document (no fixed-height inner scroll container),
    // so tall pages stay fully reachable on every browser and on mobile where
    // 100vh is larger than the visible viewport.
    <div className="min-h-screen bg-gray-50 lg:flex lg:items-start">
      {/* Sidebar */}
      <Sidebar
        user={user}
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />

      {/* Main content */}
      <div className="flex flex-col flex-1 min-w-0">
        {/* Header */}
        <Header
          user={user}
          onMenuClick={() => setSidebarOpen(!sidebarOpen)}
          onLogout={onLogout}
        />

        {/* Page content */}
        <main className="flex-1 p-6">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;
